export const DERIVATIVE_LEVERAGE_KEY = 'crypto.perpetual.leverage';
export const DERIVATIVE_ORDER_CONFIRMATION_KEY =
  'crypto.perpetual.order.confirmation';
export const SPOT_OCO_ORDER_CANCEL_CONFIRMATION_KEY =
  'crypto.spot.order.oco.cancel';
export const OEX_OCO_SPOT_ORDER_CONFIRMATION_KEY = 'crypto.oex.spot.order.oco';
export const OEX_OCO_DERIV_ORDER_CONFIRMATION_KEY =
  'crypto.oex.deriv.order.oco';
export const OEX_OCO_SPOT_CANCEL_CONFIRMATION_KEY =
  'crypto.oex.spot.order.oco.cancel';
export const OEX_OCO_DERIV_CANCEL_CONFIRMATION_KEY =
  'crypto.oex.deriv.order.oco.cancel';
export const SUB_ACCOUNT_UUID = 'crypto.subAccountUUID';
export const SUB_ACCOUNT_TRADE_UUID = 'crypto.trade.accountUUID';
export const DEFAULT_TRADE_INSTRUMENTS = 'crypto.trade.defaultInstruments';
export const DUST_SHOWED = 'crypto.dustShowed';
export const SET_UP_2FA = 'crypto.setup.2fa';
export const GRID_INTRO_SHOWED = 'crypto.gridIntroShowed';
export const GRID_TRALLING_UP_SHOWED = 'crypto.gridTrailingUpShowed';
export const ORDER_PANEL_FILTERS_KEY = 'crypto.trade.userPanel.filters';
export const DASHBOARD_WALLET_BALANCE_FILTERS_KEY =
  'crypto.dashboard.walletBalance.filters';
export const LOCALIZATION_HK_PASSWORD_CHANGE_DISMISS =
  'crypto.localization.hk.passwordChange.dismiss';
export const DASHBOARD_OTC_CONVERT_PROMOTION =
  'crypto.dashboard.convert.promotion';
export const NEW_DEPOSIT_ADDRESS_CONFIRM_NOT_SHOW =
  'crypto.depositAddress.createConfirm.notShow';
export const QUOTED_WITHDRAWAL_FEE = 'crypto.quotedWithdrawalFee';
export const TMX_SESSION_ID = 'crypto.tmxSessionId';

/**
 * Trading UI
 */
export const TRADE_MARKET = 'crypto.trade.market';
export const TRADE_MARKET_BOOK = 'crypto.trade.market.book';

// logging
export const X_WEB_ENABLE_LOGGING = 'x_web_enable_logging';

// OrderBook
export const X_WEB_ORDER_BOOK_SETTINGS = 'x_web_order_book_settings';

// Layout Management
export const X_WEB_LAYOUTS = 'x-web:layouts';
export const X_WEB_CURRENT_LAYOUT_ID = 'x-web:current-layout-id';
export const getLayoutStorageKey = (layoutId: string) => `layout:${layoutId}`;

// KYC Gate
export const KYC_GATE_DISMISSED_KEY = 'x-web:kyc-gate-dismissed';
